import * as React from "react";
import type { SVGProps } from "react";
const SvgEvercopyLogoLight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={461}
    height={79}
    fill="none"
    {...props}
  >
    <mask
      id="everycopy-logo_svg__a"
      width={49}
      height={29}
      x={0}
      y={39}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: "luminance",
      }}
    >
      <path fill="#fff" d="M.104 39.666h48.374V67.97H.104V39.667Z" />
    </mask>
    <g mask="url(#everycopy-logo_svg__a)">
      <path
        fill="#FD3C34"
        fillRule="evenodd"
        d="M41.364 57.166-.366 68.198v-7.521c0-4.14 3.199-8.36 7.095-9.407l41.75-11.03v7.52c0 4.136-3.198 8.36-7.115 9.406Z"
        clipRule="evenodd"
      />
    </g>
    <mask
      id="everycopy-logo_svg__b"
      width={49}
      height={29}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: "luminance",
      }}
    >
      <path fill="#fff" d="M.104.422h48.374V29H.104V.422Z" />
    </mask>
    <g mask="url(#everycopy-logo_svg__b)">
      <path
        fill="#FFC2C2"
        fillRule="evenodd"
        d="M41.364 17.354-.366 28.391v-7.526c0-4.136 3.199-8.36 7.095-9.401L48.479.427v7.526c0 4.136-3.198 8.36-7.115 9.401Z"
        clipRule="evenodd"
      />
    </g>
    <mask
      id="everycopy-logo_svg__c"
      width={49}
      height={30}
      x={0}
      y={19}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: "luminance",
      }}
    >
      <path fill="#fff" d="M.104 19.666h48.374V49H.104V19.666Z" />
    </mask>
    <g mask="url(#everycopy-logo_svg__c)">
      <path
        fill="#FC5D56"
        fillRule="evenodd"
        d="M41.364 37.02-.366 48.073v-7.521c0-4.14 3.199-8.36 7.095-9.407l41.75-11.03v7.52c0 4.14-3.198 8.36-7.115 9.385Z"
        clipRule="evenodd"
      />
    </g>
    <path
      fill="#fff"
      d="M83.246 33.033h21.958c-.114-2.818-1.104-5.172-2.979-7.063-1.875-1.9-4.557-2.854-8.041-2.854-3.183 0-5.76.995-7.73 2.98-1.958 1.99-3.03 4.302-3.208 6.937ZM106.413 44.7l9 2.854c-1.292 4.099-3.703 7.479-7.229 10.146-3.516 2.666-7.844 4-12.98 4-6.375 0-11.786-2.172-16.229-6.521-4.448-4.344-6.666-10.167-6.666-17.459 0-6.859 2.156-12.489 6.479-16.895C83.106 16.408 88.21 14.2 94.1 14.2c6.86 0 12.214 2.099 16.063 6.291 3.859 4.198 5.791 9.85 5.791 16.959 0 1.89-.093 3.02-.27 3.395H82.975c.125 3.365 1.36 6.146 3.709 8.355 2.359 2.208 5.198 3.312 8.52 3.312 5.75 0 9.485-2.604 11.209-7.812ZM166.6 15.575l-17.562 44.75h-10.667l-18.187-44.75h11.77l11.855 31.979 11.583-31.98H166.6ZM181.844 33.033h21.958c-.114-2.818-1.104-5.172-2.979-7.063-1.875-1.9-4.557-2.854-8.042-2.854-3.182 0-5.76.995-7.729 2.98-1.958 1.99-3.031 4.302-3.208 6.937ZM205.01 44.7l9 2.854c-1.291 4.099-3.703 7.479-7.229 10.146-3.515 2.666-7.843 4-12.979 4-6.375 0-11.786-2.172-16.229-6.521-4.448-4.344-6.667-10.167-6.667-17.459 0-6.859 2.156-12.489 6.479-16.895 4.318-4.417 9.422-6.625 15.313-6.625 6.859 0 12.213 2.099 16.062 6.291 3.86 4.198 5.792 9.85 5.792 16.959 0 1.89-.094 3.02-.271 3.395h-32.708c.125 3.365 1.359 6.146 3.708 8.355 2.36 2.208 5.198 3.312 8.521 3.312 5.75 0 9.484-2.604 11.208-7.812ZM250.949 15.304v10.833a24.497 24.497 0 0 0-3.5-.27c-8.015 0-12.021 4.385-12.021 13.145v21.313h-10.666v-44.75h10.375v7.166c1.041-2.385 2.718-4.27 5.041-5.645 2.334-1.386 4.969-2.084 7.917-2.084.984 0 1.938.1 2.854.292ZM279.159 24.033c-3.432 0-6.344 1.245-8.729 3.73-2.391 2.473-3.584 5.853-3.584 10.145 0 4.349 1.209 7.781 3.625 10.292 2.417 2.515 5.375 3.77 8.875 3.77 3.125 0 5.615-.838 7.48-2.52 1.875-1.693 3.114-3.61 3.729-5.75l9.375 3.395c-1.224 3.99-3.599 7.417-7.125 10.292-3.532 2.875-8.016 4.313-13.459 4.313-6.557 0-12.057-2.26-16.5-6.792-4.448-4.542-6.666-10.208-6.666-17 0-6.86 2.187-12.526 6.562-17 4.386-4.469 9.834-6.708 16.334-6.708 5.567 0 10.109 1.437 13.625 4.312 3.526 2.875 5.812 6.334 6.854 10.375l-9.563 3.5c-.614-2.333-1.791-4.302-3.541-5.916-1.74-1.625-4.167-2.438-7.292-2.438ZM320.182 48.325c2.417 2.541 5.365 3.812 8.854 3.812 3.5 0 6.459-1.25 8.875-3.75 2.428-2.51 3.646-6.005 3.646-10.479 0-4.417-1.218-7.86-3.646-10.333-2.416-2.485-5.375-3.73-8.875-3.73-3.489 0-6.437 1.245-8.854 3.73-2.416 2.474-3.625 5.916-3.625 10.333 0 4.406 1.209 7.875 3.625 10.417Zm8.875-34.125c6.735 0 12.292 2.24 16.667 6.708 4.385 4.474 6.583 10.14 6.583 17 0 6.865-2.198 12.542-6.583 17.042-4.375 4.5-9.932 6.75-16.667 6.75-6.682 0-12.218-2.25-16.604-6.75-4.375-4.5-6.562-10.177-6.562-17.042 0-6.86 2.187-12.526 6.562-17 4.386-4.469 9.922-6.708 16.604-6.708ZM373.158 77.783h-10.562V15.575h10.291v6.063c1.167-2.027 3-3.714 5.5-5.063 2.511-1.344 5.427-2.02 8.75-2.02 6.427 0 11.48 2.197 15.146 6.582 3.677 4.375 5.521 9.97 5.521 16.771 0 6.792-1.932 12.412-5.792 16.855-3.864 4.447-8.948 6.666-15.25 6.666-3.073 0-5.802-.583-8.187-1.75-2.391-1.166-4.198-2.635-5.417-4.416v22.52Zm23.979-39.875c0-4.166-1.104-7.52-3.312-10.062-2.198-2.542-5.099-3.813-8.708-3.813-3.558 0-6.454 1.271-8.688 3.813-2.24 2.541-3.354 5.896-3.354 10.062 0 4.224 1.114 7.625 3.354 10.209 2.234 2.573 5.125 3.854 8.667 3.854 3.552 0 6.448-1.281 8.687-3.854 2.235-2.584 3.354-5.985 3.354-10.209ZM431.701 78.429h-11.396l10.75-23.438-19.125-39.416h12.041l12.875 28.291 12.042-28.291h11.292l-28.479 62.854Z"
    />
  </svg>
);
export default SvgEvercopyLogoLight;
